import { withAuthenticationRequired } from '@tom-ui/utils'
import { EquipmentOperatorContainer, OperatorLanding, useOperationsStore } from '@tom-ui/operations'
import { observer } from 'mobx-react-lite'
import { EquipmentOperatorStepper } from './EquipmentOperatorStepper'

export const EquipmentOperator = withAuthenticationRequired(
  observer(() => {
    const { equipmentOperatorLandingUIStore } = useOperationsStore()

    return (
      <>
        {equipmentOperatorLandingUIStore.isFulfilled ? (
          <>
            <EquipmentOperatorContainer />
            <EquipmentOperatorStepper />
          </>
        ) : (
          <OperatorLanding />
        )}
      </>
    )
  }),
)
